'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _crossFetch = require('cross-fetch');

var _crossFetch2 = _interopRequireDefault(_crossFetch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @param {Object} config -
 * @param {string} config.apiKey - The Google Geocoding API key.
 * @param {number} [config.maxPendingRequests=100] - The maximum allowed pending
 *   geocoding requests.
 */
var GoogleGeocodingService = function () {
  function GoogleGeocodingService(config) {
    _classCallCheck(this, GoogleGeocodingService);

    this._ = {
      // Will be cached by the address. Not sure yet whether the results of geocoding
      // are case-sensitive. So, keying off the geocoded address as is.
      cache: {
        '': null // Cache the empty address as null.
      },
      config: _extends({}, config, {
        maxPendingRequests: typeof config.maxPendingRequests === 'number' ? config.maxPendingRequests : 100
      }),
      fetchCount: 0 // Number of pending requests.
    };
  }

  _createClass(GoogleGeocodingService, [{
    key: 'geocode',
    value: function geocode(address, overridingApiKey) {
      var _this = this;

      // console.log('GoogleGeocodingService#geocode');
      // console.log(address);
      return new Promise(function (resolve, reject) {
        var cachedResults = _this._.cache[address];
        if (cachedResults !== undefined /* Note: null is okay. */) {
            resolve(cachedResults);
            // console.log('Cache HIT');
            return;
          }

        _this._.fetchCount += 1;
        if (_this._.fetchCount <= _this._.config.maxPendingRequests) {
          var apiKey = overridingApiKey || _this._.config.apiKey;
          var urlStr = ['https://maps.googleapis.com/maps/api/geocode/json', '?address=' + encodeURIComponent(address), '&key=' + encodeURIComponent(apiKey)].join('');
          (0, _crossFetch2.default)(urlStr).then(function (res) {
            _this._.fetchCount -= 1;
            if (res.ok) {
              res.json().then(function (geoRes) {
                var results = geoRes.results,
                    status = geoRes.status;

                if (Array.isArray(results) && (status === 'OK' || status === 'ZERO_RESULTS')) {
                  _this._.cache[address] = results;
                  resolve(results);
                } else {
                  reject(Error(status));
                }
              }).catch(function (reason) {
                var error = reason;
                if (!(error instanceof Error)) {
                  error = Error(reason);
                }
                reject(error);
              });
            } else {
              reject(Error(res.status + ' ' + res.statusText));
            }
          }).catch(function (reason) {
            _this._.fetchCount -= 1;
            var error = reason;
            if (!(error instanceof Error)) {
              error = Error(reason);
            }
            reject(error);
          });
        } else {
          _this._.fetchCount -= 1;
          reject(Error('Exceeded maximum concurrent geocode requests of ' + _this._.config.maxPendingRequests + '.'));
        }
      });
    }
  }]);

  return GoogleGeocodingService;
}();

exports.default = GoogleGeocodingService;